import { defineStore } from "pinia";
export const useLoginStore = defineStore("loginStore", {
  state: () => ({
    user: {},
    appScopes: [],
    loggedIn: false,
    viewSettings: false,
  }),
  getters: {
    getUser(state) {
      return state.user;
    },
    getAppScopes(state) {
      return state.appScopes;
    },
    getLoggedIn(state) {
      return state.loggedIn;
    },
    getViewSettings(state) {
      return state.viewSettings;
    },
    isAdmin(state) {
      return state.user?.userType?.name === "Admin";
    },
    isLender(state) {
      return state.user?.userType?.name === 'Lender';
    },
  },
  actions: {
    setUser(user) {
      this.user = user;
    },
    setAppScopes(appScopes) {
      this.appScopes = appScopes;
    },
    setLoggedIn(loggedIn) {
      this.loggedIn = loggedIn;
    },
    setViewSettings(viewSettings) {
      this.viewSettings = viewSettings;
    },
  },
  persist: true,
});
